import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AnalysisService {
    private http = inject(HttpClient);
    private readonly API_URL = '/api/reporting/analysis';

    private getParams(startDate?: string, endDate?: string, projectId?: string, userId?: string) {
        let params: any = {};
        // Append T00:00:00Z to ensure backend treats it as UTC
        if (startDate) params['StartDate'] = `${startDate}T00:00:00Z`;
        if (endDate) params['EndDate'] = `${endDate}T23:59:59Z`;
        if (projectId) params['ProjectId'] = projectId;
        if (userId) params['UserId'] = userId;
        return { params };
    }

    getWeeklyAnalysis(startDate?: string, endDate?: string, projectId?: string, userId?: string): Observable<any> {
        return this.http.get<any>(`${this.API_URL}/weekly`, this.getParams(startDate, endDate, projectId, userId));
    }

    getProjectPersonnelEffort(startDate?: string, endDate?: string): Observable<any> {
        return this.http.get<any>(`${this.API_URL}/project-personnel-effort`, this.getParams(startDate, endDate));
    }

    getProjectsAnalysis(startDate?: string, endDate?: string): Observable<any> {
        return this.http.get<any>(`${this.API_URL}/projects`, this.getParams(startDate, endDate));
    }

    getPersonnelAnalysis(startDate?: string, endDate?: string): Observable<any> {
        return this.http.get<any>(`${this.API_URL}/personnel`, this.getParams(startDate, endDate));
    }

    getMonthlyAnalysis(startDate?: string, endDate?: string, projectId?: string, userId?: string): Observable<any> {
        return this.http.get<any>(`${this.API_URL}/monthly`, this.getParams(startDate, endDate, projectId, userId));
    }

    getDailyEffort(startDate?: string, endDate?: string, projectId?: string, userId?: string): Observable<any> {
        return this.http.get<any>(`${this.API_URL}/daily-effort`, this.getParams(startDate, endDate, projectId, userId));
    }

    exportDailyReportPdf(startDate?: string, endDate?: string, projectIds?: string[], userIds?: string[]): Observable<any> {
        const params = this.buildPdfParams(startDate, endDate, projectIds, userIds);
        return this.http.get(`/api/reports/daily/pdf`, { params, responseType: 'blob', observe: 'response' });
    }

    exportWeeklyReportPdf(startDate?: string, endDate?: string, projectIds?: string[], userIds?: string[]): Observable<any> {
        const params = this.buildPdfParams(startDate, endDate, projectIds, userIds);
        return this.http.get(`/api/reports/weekly/pdf`, { params, responseType: 'blob', observe: 'response' });
    }

    exportMonthlyReportPdf(startDate?: string, endDate?: string, projectIds?: string[], userIds?: string[]): Observable<any> {
        const params = this.buildPdfParams(startDate, endDate, projectIds, userIds);
        return this.http.get(`/api/reports/monthly/pdf`, { params, responseType: 'blob', observe: 'response' });
    }

    private buildPdfParams(startDate?: string, endDate?: string, projectIds?: string[], userIds?: string[]): any {
        let params: any = {};
        if (startDate) params['startDate'] = startDate;
        if (endDate) params['endDate'] = endDate;
        if (projectIds && projectIds.length > 0) params['projectIds'] = projectIds.join(',');
        if (userIds && userIds.length > 0) params['userIds'] = userIds.join(',');
        return params;
    }
}
